export const UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS = 'UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS';

export const updateProcessStatementCommentVisibilitySuccess = ({ year, modules }) => ({
    type: UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_SUCCESS,
    payload: { year, modules },
});
